import {Editor, Transforms} from 'slate';

function changeChoiceGroupLimit (editor, limit) {
  // eslint-disable-next-line no-unused-vars
  const [formGroup, formGroupPath] = Editor.above(editor, {
    match: (n) => n.type === 'form-group',
  });

  Transforms.setNodes(
    editor,
    {limit},
    {
      match: (n) => n.type === 'choice-group',
      at: formGroupPath,
    }
  );
}

export default changeChoiceGroupLimit;
